// generated from 8 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const facebookFriendsFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("facebook_friends_filter"),
  comparison_key: z.enum([
    "1", // 5 (62.50%)
    "3", // 2 (25.00%)
    "5", // 1 (12.50%)
  ]),
  display_name: z.string(),
  // undefined: 3 (37.50%), defined 5 (62.50%)
  raw_value: z.literal(100).optional(),
  value: z.literal(100),
  varies_by_app_group: z.literal(false),
});
